<template>
    <div ref="Calendar" class="gz-checkups__calendar">
        <div 
            class="gz-checkups__calendar__item js-calendar"
            v-for="(item, index) in 12"
            :key="index"
        ></div>
    </div>
</template>

<script>
export default {
    name: 'CheckupCalendar',

    props: {
        dates: Array
    },
    mounted() {
        if (this.dates.length) this.setDates()
    },
    methods: {
        setDates() {
            let arr = this.$refs.Calendar.querySelectorAll('.js-calendar')
            
            this.dates.forEach((item, index) => {
                let date = item.slice(0, item.indexOf('T'))
                date.slice(5, 10).slice(1, 2)
                
                const day = new Date(item).getUTCDate()

                let num = parseInt(date.slice(5, 10).slice(0, 2))
                
                const div = document.createElement('div')
                const span = document.createElement('span')
                div.classList.add('gz-checkups__calendar__item__subitem')
                div.style.backgroundColor = '#F2D51B'
                span.innerHTML = day
                div.append(span)
                
                arr[num-1].append(div)
            })
        }
    }
}
</script>